import { object, string } from "yup";

export let schema = (t) => 
    object({
      clinicName: string()
      .required(t("validation:required-field"))
      .trim(),
      address: string()
      .required(t("validation:required-field"))
      .trim(),
      district: string()
      .required(t("validation:required-field"))
      .trim(),
      province: string()
      .required(t("validation:required-field"))
      .trim(),
      city: string()
      .required(t("validation:required-field"))
      .trim(),
    //   zipCode: string()
    //   .required(t("validation:required-field"))
    //   .trim(),
      phoneNumber: string()
      .required(t("validation:required-field"))
      .transform((value) => (value ? value.replace(/[-\s]/g, "") : ""))
      .test(
        "hasExactDigits",
        t("validation:invalid-phone-number"),
        (value) => {
          if (!value) return false;
          return value.length === 10 && /^\d{10}$/.test(value);
        }
      )
      .trim(),
    //   email: string()
    // //   .required(t("validation:required-field"))
    //   .nullable()
    //   .notRequired()
    //   .matches(
    //     // /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
    //     /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,4}$/,
    //     t("validation:invalid-phone-number"),
    //   ),
        email:
             string()
            .transform((v) => (v === "" ? null : v))
            .nullable()
            .notRequired()
            .test("is-empty-or-email", t("validation:invalid-email"), (value) => {
            if (!value) return true;
            return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
        }),
    })
